import {AbstractGuard} from '../../../bonding_shared/components/abstract-guard';
import {LoggedUserService} from '../../../bonding_shared/services';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {CompanyElementaryRight} from '../../../bonding_shared/model/dictionary-ids';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class CompanySearchGuard extends AbstractGuard {
  constructor(loggedUserService: LoggedUserService, router: Router) {
    super(loggedUserService, router);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return (
      this.checkRight(state.url, CompanyElementaryRight.COMPANY_SEARCH) ||
      this.checkRight(state.url, CompanyElementaryRight.COMPANY_DETAIL_SEARCH)
    );
  }
}
